
      import { ServiceFormPage } from '/src/features/service-form/service-form-page.ts';
      import { notificationService } from '/src/shared/services/notification-service.ts';
      import { authStore } from '/src/shared/stores/auth-store.ts';
      import { t } from '/src/shared/i18n/index.ts';

      document.addEventListener('DOMContentLoaded', () => {
        // Show login prompt for unauthenticated users
        if (!authStore.isAuthenticated()) {
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('from') !== 'login') {
            setTimeout(() => {
              notificationService.info(t('service.userNoticeHint'), {
                duration: 5000,
                actions: [
                  {
                    label: t('service.signInNow'),
                    action: () => {
                      const currentPath = encodeURIComponent(
                        window.location.pathname + window.location.search
                      );
                      window.location.href = `/pages/auth/login.html?return=${currentPath}`;
                    },
                    primary: true,
                  },
                ],
              });
            }, 2000);
          }
        }

        // Auto-fill appointment time (+1 hour) only if field is empty after cache restore
        setTimeout(() => {
          const appointmentInput = document.querySelector('input[name="appointmentDate"]');
          if (appointmentInput && !appointmentInput.value) {
            const now = new Date();
            now.setHours(now.getHours() + 1);
            appointmentInput.value = now.toISOString().slice(0, 16);
          }
        }, 1000);

        new ServiceFormPage({
          formType: 'inspection',
          formEl: 'inspectionForm',
          repeatingGroups: [
            {
              containerId: 'checklistContainer',
              min: 1,
              max: 5,
              addLabel: t('dynamic.addChecklistItem'),
              removeLabel: t('common.delete'),
              fields: [
                {
                  name: 'checklist',
                  type: 'text',
                  placeholder: t('misc.enterChecklist'),
                  span: 'full',
                },
              ],
            },
          ],
          serverPrefill: true,
          excludeFromPrefill: ['address', 'appointmentDate'],
          preSubmit: async () => {
            if (!authStore.isAuthenticated()) {
              notificationService.error(t('common.pleaseLoginFirst'), {
                actions: [
                  {
                    label: t('common.goLogin'),
                    action: () => {
                      const currentPath = encodeURIComponent(
                        window.location.pathname + window.location.search
                      );
                      window.location.href = `/pages/auth/login.html?return=${currentPath}`;
                    },
                    primary: true,
                  },
                ],
              });
              return false;
            }
            return showUserNoticeModal();
          },
          messages: {
            loading: t('service.submittingInspection'),
            success: t('service.inspectionSuccess'),
          },
        });
      });

      function showUserNoticeModal() {
        return new Promise(resolve => {
          const modal = document.createElement('div');
          modal.className =
            'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4';

          modal.innerHTML = `
            <div class="bg-white rounded-sm max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
              <div class="flex items-center justify-between p-6 border-b border-gray-200 bg-gray-50">
                <div class="flex items-center space-x-3">
                  <div class="w-10 h-10 bg-gold/10 rounded-sm flex items-center justify-center">
                    <i class="fas fa-info-circle text-lg text-gold-ink"></i>
                  </div>
                  <div>
                    <h3 class="ea-disp text-xl font-medium text-gray-900">服务须知</h3>
                    <p class="text-sm text-gray-600">请仔细阅读以下条款，确保您了解服务详情</p>
                  </div>
                </div>
                <button type="button" class="text-gray-400 hover:text-gray-600 transition-colors" id="close-notice-btn">
                  <i class="fas fa-times text-xl"></i>
                </button>
              </div>

              <div class="flex-1 overflow-y-auto p-6">
                <div class="space-y-8">
                  <div class="bg-amber-50 border border-amber-200 rounded-lg p-5">
                    <div class="flex items-center space-x-2 mb-4">
                      <i class="fas fa-exclamation-triangle text-amber-600"></i>
                      <h4 class="text-lg font-semibold text-amber-800">重要注意事项</h4>
                    </div>
                    <div class="space-y-4 text-sm text-gray-700">
                      <div class="bg-white rounded-md p-4 border border-amber-100">
                        <h5 class="font-medium text-gray-900 mb-2 flex items-center">
                          <span class="w-6 h-6 bg-amber-100 rounded-full text-amber-700 text-xs flex items-center justify-center mr-2">1</span>
                          付费政策
                        </h5>
                        <p class="text-gray-700 pl-8">服务需预先付费，支持澳币（AUD）或人民币（RMB）支付。</p>
                      </div>
                      <div class="bg-white rounded-md p-4 border border-amber-100">
                        <h5 class="font-medium text-gray-900 mb-3 flex items-center">
                          <span class="w-6 h-6 bg-amber-100 rounded-full text-amber-700 text-xs flex items-center justify-center mr-2">2</span>
                          退改规定
                        </h5>
                        <div class="pl-8 space-y-2">
                          <div class="flex items-start space-x-2">
                            <span class="text-red-500 mt-1">•</span>
                            <span><strong>当天临时取消：</strong>不予退款</span>
                          </div>
                          <div class="flex items-start space-x-2">
                            <span class="text-yellow-500 mt-1">•</span>
                            <span><strong>提前1-3天通知：</strong>退还50%费用</span>
                          </div>
                          <div class="flex items-start space-x-2">
                            <span class="text-green-500 mt-1">•</span>
                            <span><strong>提前3天以上通知：</strong>全额退款</span>
                          </div>
                        </div>
                      </div>
                      <div class="bg-white rounded-md p-4 border border-amber-100">
                        <h5 class="font-medium text-gray-900 mb-3 flex items-center">
                          <span class="w-6 h-6 bg-amber-100 rounded-full text-amber-700 text-xs flex items-center justify-center mr-2">3</span>
                          看房须知
                        </h5>
                        <div class="pl-8 space-y-2">
                          <div class="flex items-start space-x-2">
                            <span class="text-blue-500 mt-1">•</span>
                            <span><strong>看房时长：</strong>一般为10-15分钟（由中介规定）</span>
                          </div>
                          <div class="flex items-start space-x-2">
                            <span class="text-blue-500 mt-1">•</span>
                            <span><strong>提问建议：</strong>请提前提供1-5个关键问题，我们会尽量向中介了解</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bg-blue-50 border border-blue-200 rounded-lg p-5">
                    <div class="flex items-center space-x-2 mb-4">
                      <i class="fas fa-home text-blue-600"></i>
                      <h4 class="text-lg font-semibold text-blue-800">代看房流程</h4>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div class="space-y-3 text-sm">
                        <div class="flex items-start space-x-3">
                          <span class="w-6 h-6 bg-blue-100 rounded-full text-blue-700 text-xs flex items-center justify-center flex-shrink-0 mt-0.5">1</span>
                          <span class="text-gray-700">到达现场，拍摄房屋周边环境视频</span>
                        </div>
                        <div class="flex items-start space-x-3">
                          <span class="w-6 h-6 bg-blue-100 rounded-full text-blue-700 text-xs flex items-center justify-center flex-shrink-0 mt-0.5">2</span>
                          <span class="text-gray-700">与中介签到，提供预约信息</span>
                        </div>
                        <div class="flex items-start space-x-3">
                          <span class="w-6 h-6 bg-blue-100 rounded-full text-blue-700 text-xs flex items-center justify-center flex-shrink-0 mt-0.5">3</span>
                          <span class="text-gray-700">进入房屋，拍摄视频/照片</span>
                        </div>
                      </div>
                      <div class="space-y-3 text-sm">
                        <div class="flex items-start space-x-3">
                          <span class="w-6 h-6 bg-blue-100 rounded-full text-blue-700 text-xs flex items-center justify-center flex-shrink-0 mt-0.5">4</span>
                          <span class="text-gray-700">检查房屋采光、隔音、家具等</span>
                        </div>
                        <div class="flex items-start space-x-3">
                          <span class="w-6 h-6 bg-blue-100 rounded-full text-blue-700 text-xs flex items-center justify-center flex-shrink-0 mt-0.5">5</span>
                          <span class="text-gray-700">向中介咨询您关心的问题</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bg-green-50 border border-green-200 rounded-lg p-5">
                    <div class="flex items-center space-x-2 mb-4">
                      <i class="fas fa-check-circle text-green-600"></i>
                      <h4 class="text-lg font-semibold text-green-800">服务内容包含</h4>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div class="space-y-2 text-sm">
                        <div class="flex items-center space-x-2">
                          <i class="fas fa-video text-green-600 w-4"></i>
                          <span class="text-gray-700">一镜到底高清视频（中介允许时）</span>
                        </div>
                        <div class="flex items-center space-x-2">
                          <i class="fas fa-map-marker-alt text-green-600 w-4"></i>
                          <span class="text-gray-700">房屋外部与周边环境展示</span>
                        </div>
                        <div class="flex items-center space-x-2">
                          <i class="fas fa-bus text-green-600 w-4"></i>
                          <span class="text-gray-700">简单交通信息介绍</span>
                        </div>
                      </div>
                      <div class="space-y-2 text-sm">
                        <div class="flex items-center space-x-2">
                          <i class="fas fa-question-circle text-green-600 w-4"></i>
                          <span class="text-gray-700">向中介咨询关键问题（最多5个）</span>
                        </div>
                        <div class="flex items-center space-x-2">
                          <i class="fas fa-search text-green-600 w-4"></i>
                          <span class="text-gray-700">检查采光、隔音、家具等基本情况</span>
                        </div>
                        <div class="flex items-center space-x-2">
                          <i class="fas fa-camera text-green-600 w-4"></i>
                          <span class="text-gray-700">详细照片和视频记录</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-col gap-4 p-6 border-t border-gray-200 bg-gray-50 md:flex-row md:items-center md:justify-between">
                <div class="flex items-center space-x-2 text-sm text-gray-600">
                  <i class="fas fa-info-circle"></i>
                  <span>请确认您已阅读并理解以上条款</span>
                </div>
                <div class="flex flex-col gap-3 md:flex-row md:space-x-3 md:gap-0">
                  <button type="button" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 transition-colors" id="cancel-notice-btn">
                    返回修改
                  </button>
                  <button type="button" class="px-6 py-2 bg-gold text-night rounded-sm hover:bg-gold-hover transition-colors flex items-center space-x-2 font-semibold" id="confirm-notice-btn">
                    <i class="fas fa-check"></i>
                    <span>我已知晓，确认提交</span>
                  </button>
                </div>
              </div>
            </div>
          `;

          document.body.appendChild(modal);
          document.body.style.overflow = 'hidden';

          const closeModal = (confirmed = false) => {
            document.body.style.overflow = '';
            modal.remove();
            resolve(confirmed);
          };

          modal
            .querySelector('#confirm-notice-btn')
            .addEventListener('click', () => closeModal(true));
          modal
            .querySelector('#cancel-notice-btn')
            .addEventListener('click', () => closeModal(false));
          modal
            .querySelector('#close-notice-btn')
            .addEventListener('click', () => closeModal(false));

          modal.addEventListener('click', e => {
            if (e.target === modal) closeModal(false);
          });

          const handleEsc = e => {
            if (e.key === 'Escape') {
              document.removeEventListener('keydown', handleEsc);
              closeModal(false);
            }
          };
          document.addEventListener('keydown', handleEsc);
        });
      }
    